/**
 * Generates the styles necessary to visually hide an element without removing screen reader access.
 * @see https://stackoverflow.com/a/62109988/6063755
 * @returns CSS styles to be applied to the component.
 */
export const generateVisuallyHiddenStyles = () => {
  // There are a variety of ways to visually hide an element, but this solution seems to be the most robust at the time of writing this code.
  return {
    border: '0px',
    padding: '0px',
    margin: '0px',
    position: 'absolute',
    height: '1px',
    width: '1px',
    overflow: 'hidden',
    clip: 'rect(1px, 1px, 1px, 1px)',
    // clip is deprecated, but is still supported at the time of writing this code
    clipPath: 'inset(50%)',
    // clipPath is the replacement for clip
    whiteSpace: 'nowrap' // Ensures that words to not get smushed together for screen readers (see https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe)

  };
};